import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import Link from "@mui/material/Link";
import ReusableAgGrid from "../../components/AgGrid/AgGrid";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

const DrilldownBody = (props) => {
  const [tableLimit, setTableLimit] = useState(2);
  const setdataLimit = (val) => {
    if (val === "showMore") {
      setTableLimit(props.body.opportunities.length);
    } else {
      setTableLimit(2);
    }
  };

  const classes = useStyle();

  // Define the height based on the "Show More/Less" state
  const gridHeight = tableLimit <= 2 ? "180px" : "70vh";

  return (
    <Grid container className={classes.root}>
      {props.body ? (
        <React.Fragment>
          <ReusableAgGrid
            rowData={props.body.opportunities.slice(0, tableLimit)}
            columnConfig={props.body.columns}
            height={gridHeight} // Pass the calculated height
          />
          {props.body.opportunities.length > 2 ? (
            <p>
              {props.body.opportunities.length > tableLimit ? (
                <>
                  <Link
                    onClick={() => setdataLimit("showMore")}
                    style={{ cursor: "pointer" }}
                  >
                    Show More
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    onClick={() => setdataLimit("showLess")}
                    style={{ cursor: "pointer" }}
                  >
                    Show Less
                  </Link>
                </>
              )}
            </p>
          ) : (
            <></>
          )}
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default DrilldownBody;
